<template>
    <article :style="cardStyle()" class="card w-100">

        <!-- TITLE -->
        <h1 class="clean-text-css desktop-element" :style="titleStyle()">{{ article.title }}</h1>
        <h1 class="clean-text-css mobile-element" :style="titleStyle(false)">{{ article.title }}</h1>

        <!-- POST INFO -->
          <div :class="`post-info ${!show.author && 'only-social-bar'}`">
            <div
              class="author-content"
              v-show="show.author"
            >
              <img src="https://e7.pngegg.com/pngimages/8/36/png-clipart-man-black-illustration-computer-icons-google-account-user-profile-iconfinder-com-icons-profile-account-profile-thumbnail.png" />
              <div class="author-content-info">
              <span
                :style="authorStyle()"
                class="author-name clean-text-css desktop-element"
              >
                {{ article.author.name }}
              </span>

              <span
                :style="authorStyle(false)"
                class="author-name clean-text-css mobile-element"
              >
                {{ article.author.name }}
              </span>
                <span v-show="show.date" :style="authorStyle()" class="post-date desktop-element">  {{ formatDate(article.scheduled_date, show.formatDate) }}</span>
                <span v-show="show.date" :style="authorStyle(false)" class="post-date mobile-element">  {{ formatDate(article.scheduled_date, show.formatDate) }}</span>
            </div>
          </div>
          <social-bar v-show="show.author" :icons="article.author" />
        </div>
        <div class="post-content content-post" v-html="article.content">
        </div>
        <div v-show="show.shareBar.display" :style="shareBarDivStyle()" class="share-bar">
            <a v-show="show.shareBar.copy" href="#"  :style="shareButtonStyle()" class="post-share-icon fas fa-link"></a>
            <a v-show="show.shareBar.email" :href="showUrl('email')" target="_blank"  :style="shareButtonStyle()" class="post-share-icon far fa-envelope"></a>
            <a v-show="show.shareBar.facebook" :href="showUrl(`facebook`)" target="_blank"  :style="shareButtonStyle()" class="post-share-icon fab fa-facebook-f"></a>
            <a v-show="show.shareBar.twitter" :href="showUrl('twitter')" target="_blank"  :style="shareButtonStyle()" class="post-share-icon icon-x"><builderall-icon code='new-twitter'></builderall-icon></a>
            <a v-show="show.shareBar.pinterest" :href="showUrl('pinterest')" target="_blank"  :style="shareButtonStyle()" class="post-share-icon fab fa-pinterest"></a>
<!--            <a v-show="show.shareBar.instagram" href="#"  :style="shareButtonStyle()" class="post-share-icon fab fa-instagram"></a>-->
            <a v-show="show.shareBar.linkedin" :href="showUrl('linkedin')" target="_blank"  :style="shareButtonStyle()" class="post-share-icon fab fa-linkedin-in"></a>
<!--            <a v-show="show.shareBar.youtube" href="#"  :style="shareButtonStyle()" class="post-share-icon fab fa-youtube"></a>-->
<!--            <a v-show="show.shareBar.medium" href="#"  :style="shareButtonStyle()" class="post-share-icon fab fa-medium-m"></a>-->
            <span class="mobile-element">
        <a v-show="show.shareBar.whatsapp"  :href="showUrl('whatsapp')" target="_blank" :style="shareButtonStyle()" class="post-share-icon fab fa-whatsapp"></a>
        <a v-show="show.shareBar.telegram" href="#" :style="shareButtonStyle()" class="post-share-icon fab fa-telegram"></a>
      </span>

        </div>
        <!-- CATEGORIES -->
        <div :style="categoryDivStyle()" class="categories-info" v-show="show.categories">
            <span v-for="category in article.categories" :key="category.url" :style="categoryStyle()">{{ category.name }}</span>
        </div>

        <!-- AUTHOR INFO -->
        <div class="post-info" v-show="show.author">
            <div class="author-content">
                <img height="50px" :src=" article.author.thumbnail" />
                <div class="author-info">
          <span :style="authorStyle()" class="author-name clean-text-css desktop-element">
           {{ article.author.name }}
            </span>

                    <span :style="authorStyle(false)" class="author-name  clean-text-css  mobile-element">
           {{ article.author.name }}
            </span>
                </div>
            </div>
            <!--      <a class="author-profile" :href="`/a/${article.author.slug}`">Filter</a>-->
        </div>
    </article>
</template>

<script>

import SocialBar from '../../Generic/SocialBarSimple';
import moment from 'moment/moment';

export default {
  name: 'Simple',
  props: ['article', 'show', 'colors', 'styles'],
  components: {
    SocialBar
  },
  methods: {
    showUrl(type) {
      let vm = this;
      if (typeof vm.article.date_cycle !== 'undefined' && vm.article.date_cycle === 'Instantaneous' && window.location.hash.indexOf('#/editor/') === -1) {
        if (type === 'facebook') {
          return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`;
        }

        if (type === 'twitter') {
          return `https://twitter.com/intent/tweet?text=${this.article.title}&url=${encodeURI(window.location.href)}`;
        }

        if (type === 'linkedin') {
          return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(window.location.href)}`;
        }

        if (type === 'pinterest') {
          return `https://pinterest.com/pin/create/button/?url=${encodeURI(window.location.href)}`;
        }

        if (type === 'whatsapp') {
          return `whatsapp://send?text=${this.article.title} - ${encodeURI(window.location.href)}`;
        }

        if (type === 'email') {
          return `mailto:subject${this.article.title}&body=${encodeURI(window.location.href)}`;
        }
      } else {
        return '#';
      }
    },
    formatDate(date, format) {
      return moment(String(date)).format(format);
    },
    cardStyle() {
      return `background-color: ${this.colors.color_1}; padding: 15px`;
    },
    shareBarDivStyle() {
      let align = this.show.shareBar.align === 'left' ? 'flex-start' : this.show.shareBar.align === 'right' ? 'flex-end' : 'center';
      return `display: flex; justify-content: ${align}; flex-wrap: wrap;`;
    },
    shareButtonStyle() {
      let prop = (this.show.shareBar.theme === 'circle') ? 'border-radius: 50%;' : '';
      return prop;
    },
    categoryDivStyle() {
      let align = this.styles.categories.align === 'left' ? 'flex-start' : this.styles.categories.align === 'right' ? 'flex-end' : 'center';
      return `margin-top: 10px; display: flex; justify-content: ${align}; flex-wrap: wrap`;
    },
    titleStyle(desktop = true) {
      return `font-family:  ${this.styles.title.family};
                  font-size: ${(desktop) ? this.styles.title.size : this.styles.title.sizeMobile} !important;
                  text-align: ${this.styles.title.align};
                  font-weight: ${this.styles.title.weight};
                  font-style: ${this.styles.title.style};
                  text-decoration: ${this.styles.title.stroke};
                  color: ${this.styles.title.color}`;
    },
    authorStyle(desktop = true) {
      return `font-family:  ${this.styles.author.family};
                  font-size: ${(desktop) ? this.styles.author.size : this.styles.author.sizeMobile} !important;
                  text-align: ${this.styles.author.align};
                  font-weight: ${this.styles.author.weight};
                  font-style: ${this.styles.author.style};
                  text-decoration: ${this.styles.author.stroke};
                  color: ${this.styles.author.color}`;
    },
    categoryStyle(desktop = true) {
      return `font-family:  ${this.styles.categories.family};
                  font-size: ${(desktop) ? this.styles.categories.size : this.styles.categories.sizeMobile} !important;
                  text-align: ${this.styles.categories.align};
                  font-weight: ${this.styles.categories.weight};
                  font-style: ${this.styles.categories.style};
                  text-decoration: ${this.styles.categories.stroke};
                  color: ${this.styles.categories.color};
                  background-color: ${this.colors.color_3};
                  margin-top: 5px`;
    }
  },
  mounted() {
  },
  wath: {
    styles() {
      // do nothing
    },
    article(value) {
      // do nothing
    }
  }
};
</script>

<style lang="scss" scoped>
    @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css);

    [data-device="mobile"] {
      .post-info {
        flex-direction: column;
      }
    }

    .post-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        margin: 30px 0px 50px 0px;

        &.only-social-bar {
            justify-content: flex-end;
        }

        a.author-profile {
            max-height: 35px;

            color: rgba(0, 0, 0, 0.54);
            border: 1px solid rgba(0, 0, 0, 0.54);
            padding: 5px;
            border-radius: 5px;
            text-decoration: none;
            transition: box-shadow 0.2s;

            &:hover {
                box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.54);

            }
        }
    }

    .author-content {
        display: flex;

        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }

        &-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 10px;

            .author-name {
                color: rgba(#000000, 0.84);
            }

            .post-date {
                color: rgba(#000000, 0.54);

            }
        }
    }

    .post-content {
        img {
            width: 100%;
        }
    }

    .categories-info {
        line-height: 45px;

        span {
            padding-left: 10px;
            padding-right: 10px;
            border-radius: 2px;
            margin-right: 3px;
            color: rgba(#000000, 0.54);
            background-color: rgba(#000000, 0.25);
        }
    }

</style>

<style scoped>
    /* Style all font awesome icons */
    .post-share-icon {
        margin-top: 5px;
        margin-left: 2px;
        padding: 15px;
        font-size: 20px;
        width: 50px;
        height: 50px;
        text-align: center;
        text-decoration: none;
    }

    /* Add a hover effect if you want */
    .post-share-icon:hover {
        opacity: 0.7;
    }

    /* Set a specific color for each brand */

    /* Facebook */
    .fa-facebook-f {
        background: #3B5998;
        color: white;
    }

    /* Twitter */
    .icon-x {
        background: #12100e;
        color: white;
        display: flex;
        justify-content: center;

        builderall-icon {
          --builderall-icon-size: 22px;
        }
    }

    /* Instagram */
    .fa-instagram {
        background: #d00174;
        color: white;
    }

    /* Linkedin */
    .fa-linkedin-in {
        background: #2867b2;
        color: white;
    }

    /* Youtube */
    .fa-pinterest {
        background: #ff0000;
        color: white;
    }

    /* Medium */
    .fa-medium-m {
        background: #12100e;
        color: white;
    }

    /* Email */
    .fa-envelope {
        background: #363636;
        color: white;
    }

    /* Copy */
    .fa-link {
        background: #363636;
        color: white;
    }

    /* whatsapp */
    .fa-whatsapp {
        background: #25D366;
        color: white;
    }

    /* telegram */
    .fa-telegram {
        background: #0088cc;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Post/themes/Simple.vue